<div class="flex flex-col items-center gap-4 p-6 min-w-[340px]">
  <div class="text-xl font-semibold text-center">
    Help Desk
  </div>

  <div *ngIf="isIapAseanMea">
    <div class="flex flex-col items-center text-center text-lg gap-2 mb-4">
      <p>{{ utils.traslatei18n('helpDeskContactMessage') }}</p>
      <a class="text-blue-600 cursor-pointer hover:underline" [href]="'mailto:' + helpDeskEmail">{{ helpDeskEmail }}</a>
    </div>
    <button mat-flat-button mat-dialog-close color="accent">{{ utils.traslatei18n('Close') }}</button>
  </div>

  <div *ngIf="!isIapAseanMea">
    <div class="p-4">
      <div *ngFor="let item of this.infosHtml">
        <a [innerHTML]="item">
        </a>
      </div>
    </div>
  </div>


</div>
